<template>
  <div v-bind:class="{ 'header header__black': this.black, 'header header__white': !this.black }">
    <!--<span>-->
      <div v-if="!this.frontpage" class="header__left">
      <input class="header__search" type="search" v-bind:class="{ 'search__black': this.black, 'search__white': !this.black }" @keyup.enter="submit" v-model="search.searchKeyword" placeholder="Typ hier je zoekterm">
      <span class="search__results">{{ results }}</span>
      </div>

      <div class="header__right">
        <ul class="header__list" v-if="!this.frontpage">
          <li @click="toggle()">SORT</li>
          <li v-if="showFilters" v-bind:class="{ active: isAsc }" @click="setSort('asc')">Oldest</li>
          <li v-if="showFilters" v-bind:class="{ active: !isAsc }" @click="setSort('desc')">Newest</li>
        </ul>
        <ul class="header__list" v-if="!this.frontpage">
          <li @click="toggle()">FONT</li>
          <li v-if="showFilters">·Normal</li>
          <li v-if="showFilters">Small</li>
        </ul>
        <div class="colorChanger__holder">
          <div v-bind:class="{ 'colorChanger__circle colorChanger__circle--active': this.black, 'colorChanger__circle colorChanger__circle--inactive': !this.black }" @click="setBlack(true)"></div>
          <div v-bind:class="{ 'colorChanger__circle colorChanger__circle--inactive': this.black, 'colorChanger__circle colorChanger__circle--active': !this.black }" @click="setBlack(false)"></div>
        </div>
      </div>
      <!-- Post font size: https://vuejs.org/v2/guide/components.html -->
    <!--</sp an>-->
  </div>
</template>

<script>
export default {
  name: 'Header',
  data: function () {
    return {
      // searchKeyword: this.term,
      showFilters: false,
      isAsc: true,
      sort: 'desc'
    }
  },
  props: ['results', 'black', 'frontpage', 'term'],
  computed: {
    search () {
      return { searchKeyword: this.term }
    }
  },
  methods: {
    submit () {
      this.$emit('enter', this.search.searchKeyword)
    },
    toggle: function () {
      this.showFilters = !this.showFilters
    },
    setBlack: function (bool) {
      // console.log('tesrtttt')
      this.$emit('changeColor', bool)
    },
    setSort (sort) {
      if (sort === 'asc') {
        this.isAsc = true
      } else {
        this.isAsc = false
      }
      this.$emit('sorting', sort)
    }
  }
}
</script>

<style scoped>
  h1 {
    color: #FFFFFF;
    font-size: 13px;
    margin: 0;
  }

  .header {
    background: rgb(0,0,0);
    background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,.95) 50%, rgba(0,0,0,0) 100%);
    width: 80%;
    color: rgba(255,255,255);
    height: 140px;
    font-family: 'fl-mono';
    position: fixed;
    padding: 56px 0 60px 120px;
    z-index: 5;
    box-sizing: border-box;
    /* margin-left: 20%; */
  }

  .header__black {
    background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,.95) 50%, rgba(0,0,0,0) 100%);
  }

  .header__white {
    background: linear-gradient(180deg, rgba(239,239,239,1) 0%, rgba(239,239,239,.95) 50%, rgba(239,239,239,0) 100%);
  }

  span {
    display: block;
    margin: 0 0 0 100px;
    font-size: 13px;
  }

  .header__left {
    float: left;
    width: 450px;
  }

  input[type=search] {
    color: white;
    border-style: none;
    border-bottom: 2px dotted #707070;
    border-radius: 0;
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 300px;
    font-family: 'fl-mono';
    font-size: 16px;
    float: left;
    margin-right: 10px;
  }

  .search__black { background: black; }
  .search__white {
    background: rgba(239, 239, 239, 1);
    color: black !important;
  }

  .search__results {
    margin-left: 20px;
    color: #707070;
    line-height: 25px;
  }

  .header__right {
    margin-right: 50px;
    float: right;
    margin-top: 4px;
  }

  ul {
    list-style-type: none;
    float: left;
    margin: 0 40px 0 0;
    padding: 0;
  }

  @keyframes enterOption {
    0%{
      opacity: 0;
      transform: translate(0, 3px);
    }
    100%{
      opacity: 1;
      transform: translate(0, 0px);
    }
  }

  li {
    width: 45px;
    color: #484848;
    opacity: 0;
    animation: enterOption .4s linear forwards;
    cursor: pointer;
    /*animation-fill-mode: both;*/
  }

  .active {
    text-decoration-line: underline;
  }

  li:nth-child(2) { animation-delay: 0s }
  li:nth-child(3) { animation-delay: .3s }
  li:nth-child(4) { animation-delay: .5s }
  li:nth-child(5) { animation-delay: .7s }

  li:first-child {
    cursor: pointer;
    color: #707070;
    animation: none;
    opacity: 1;
  }

  .colorChanger__holder {
    float: left;
    margin-top: -8px;
  }

  .colorChanger__circle {
    width: 30px;
    height: 30px;
    background: white;
    border-radius: 100%;
    float: left;
    position: relative;
  }
  .colorChanger__circle:first-child {
    z-index: 10;
    background: #666;
  }

  .colorChanger__circle:nth-child(2) {
    margin-left: -10px;
    z-index: 1;
    transform: scale(.8, .8);
  }

  .colorChanger__circle--active {
    animation: grow .3s linear
  }

  .colorChanger__circle--inactive {
    cursor: pointer;
  }
  .colorChanger__circle--inactive:hover {
    transform: scale(.85, .85);
  }

  @keyframes grow {
   0%{
     transform: scale(.85, .85);
   }
   100% {
     transform: scale(1, 1);
   }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue